import { generateTableSlice } from "./sliceTable";

const sliceFinancePatientTable = generateTableSlice("financePatient");

export const ActionsFinancePatientTable = sliceFinancePatientTable.actions;
export const ReducerFinancePatientTable = sliceFinancePatientTable.reducer;

const sliceFinanceCaregiverTable = generateTableSlice("financeCaregiver");

export const ActionsFinanceCaregiverTable = sliceFinanceCaregiverTable.actions;
export const ReducerFinanceCaregiverTable = sliceFinanceCaregiverTable.reducer;
